// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const TokenRotationBehaviorSchema = z.enum(['ROTATES','STABLE','UNKNOWN'] as const);

export type TokenRotationBehaviorType = `${z.infer<typeof TokenRotationBehaviorSchema>}`

export default TokenRotationBehaviorSchema;
